import Authentication from '../root.component';

export const withAuthorization = (C) => {
    return function WrappedComponent(props) {
        return (
            <Authentication {...props} Component={C}></Authentication>
        );
    }
}